// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__1UU8J","spinner":"Spinner_spinner__H2HDD","load8":"Spinner_load8__MoDIZ"};